import {Component} from 'substance'

class EditorComponent extends Component {

    constructor(...args) {
        super(...args)
        this.editor = null
        this.onContentChange = null
    }

    shouldRerender() {
        return true
    }

    didMount() {
        // Give back current source
        this.props.onContentChange(this.props.source, null)

        window.require(['vs/editor/editor.main'], () => {
            this.editor = window.monaco.editor.create(
                document.getElementById('configurationtesttool'),
                {
                    value: this.props.source,
                    language: 'json',
                    renderIndentLines: true,
                    renderLineHighlight: 'gutter',
                    minimap: {
                        enabled: false
                    }
                }
            )

            // Callback to give back the current source continously
            this.editor.model.onDidChangeContent((change) => {
                this.props.onContentChange(this.editor.getValue(), change)
            })
        })
    }

    render($$) {
        return $$('div').attr('id', 'configurationtesttool')
    }
}

export default EditorComponent
